
import React, { createContext, useContext, useState } from 'react';
import { ActiveVideo } from '../types';

interface VideoContextType {
  activeVideo: ActiveVideo | null;
  setActiveVideo: React.Dispatch<React.SetStateAction<ActiveVideo | null>>;
  isPipVisible: boolean;
  setIsPipVisible: (visible: boolean) => void;
}

const VideoContext = createContext<VideoContextType>({
  activeVideo: null,
  setActiveVideo: () => {},
  isPipVisible: false,
  setIsPipVisible: () => {}
});

export const useVideo = () => useContext(VideoContext);

export const VideoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeVideo, setActiveVideo] = useState<ActiveVideo | null>(null);
  const [isPipVisible, setIsPipVisible] = useState(false);

  return (
    <VideoContext.Provider value={{ activeVideo, setActiveVideo, isPipVisible, setIsPipVisible }}>
      {children}
    </VideoContext.Provider>
  );
};
